import { accorder } from '../plural.js';
/**
 * Le français, catalogue de référence.
 *
 * C'est le texte du produit tel qu'il était écrit avant que ces chaînes ne soient
 * extraites — chaque valeur ici doit rester identique à ce que l'écran affichait, pour
 * qu'activer l'internationalisation ne change rien pour un parent qui lit déjà en
 * français.
 */
export const fr = {
    langue: {
        selecteur: 'Langue',
    },
    coquille: {
        sautContenu: 'Aller au contenu',
        deconnexion: 'Se déconnecter',
        versionInconnue: 'inconnue',
        version: (version, horodatage) => `Version ${version} — build du ${horodatage}`,
        signature: '— Repère, organisation & sérénité',
    },
    compte: {
        menu: 'Menu',
        monCompte: 'Mon compte',
        options: 'Options',
        aide: 'Aide',
        mesDossiers: 'Mes dossiers',
        nouveauDossier: 'Nouveau dossier',
        identiteTitre: 'Votre compte',
        formule: 'Formule',
        situation: 'Situation',
        debut: 'Depuis le',
        echeance: 'Jusqu’au',
        origine: 'Origine',
        origines: {
            stripe: 'Abonnement payé',
            code_essai: 'Code d’essai',
            geste: 'Geste commercial',
        },
        statuts: {
            none: 'Aucun abonnement',
            trialing: 'Essai en cours',
            active: 'Actif',
            past_due: 'Paiement en attente',
            canceled: 'Résilié',
        },
        resiliationProgrammee: 'Votre abonnement s’arrêtera à la fin de la période en cours.',
        essaiJusquau: (date) => `Essai gratuit jusqu’au ${date}.`,
        accesCouvert: 'Votre écriture est ouverte par la formule Duo souscrite sur un dossier que vous ' +
            'partagez. Vous pouvez à tout moment prendre votre propre abonnement.',
        accesProfessionnel: 'Vous écrivez au titre d’un accès professionnel ouvert par un parent, pas d’un abonnement.',
        factures: 'Mes factures et mon paiement',
        ouvertureFactures: 'Ouverture…',
        facturesIndisponibles: 'Aucune facture : votre accès n’est pas passé par un paiement par carte.',
        erreurFactures: 'La page de facturation n’a pas pu s’ouvrir',
        dossiersTitre: 'Vos dossiers',
        parent: (rang) => `Parent ${rang}`,
        placeLibre: 'Place encore libre',
        aucunDossier: 'Vous n’avez encore aucun dossier.',
        optionsTitre: 'Options',
        retourPrecedent: 'Retour',
        apparence: 'Apparence',
        apparenceAide: '« Automatique » suit le réglage de votre appareil : il s’assombrit le soir sans que vous y pensiez.',
        langueTitre: 'Langue',
        langueAide: 'La langue de l’application et celle de ses e-mails.',
        lectureIA: 'Lecture des justificatifs',
        lectureIAAide: 'Quand vous joignez la photo d’un ticket à une dépense, Repère peut la lire et vous ' +
            'proposer le montant, la date et la catégorie. La photo est envoyée à Mistral, notre ' +
            'prestataire d’IA européen, à cette seule fin, et n’y est pas conservée. C’est la ' +
            'seule donnée de votre dossier qui sorte de nos serveurs.',
        lectureIAActive: 'Lire mes justificatifs',
        lectureIAInactive: 'Ne rien envoyer, je saisis moi-même',
        notificationsTitre: 'Notifications',
        silenceAide: 'Pendant ces heures, votre téléphone reste muet. Ce qui arrive n’est pas perdu : ' +
            'c’est gardé, puis remis en une seule fois à la fin du silence.',
        silenceActive: 'Me laisser tranquille la nuit',
        silenceDesactive: 'Me prévenir à toute heure',
        silenceDebut: 'À partir de',
        silenceFin: 'Jusqu’à',
        silenceNote: (fin) => `Ce qui arrive pendant le silence vous est remis à ${fin}, en un seul message. ` +
            'Une alerte urgente, elle, passe outre.',
        silenceNoteInactif: 'Vous êtes prévenu dès qu’il se passe quelque chose, à n’importe quelle heure.',
        emailTitre: 'E-mails',
        emailAide: 'Ce réglage ne concerne que votre boîte aux lettres. Les notifications sur votre ' +
            'téléphone, elles, ne changent pas.',
        emailImmediat: 'Un e-mail à chaque fois',
        emailQuotidien: 'Un seul résumé par jour',
        emailImmediatNote: 'Vous recevez un e-mail dès qu’il se passe quelque chose — sauf pendant vos heures ' +
            'silencieuses.',
        emailQuotidienNote: (heure) => `Un seul e-mail par jour, à ${heure}, avec le compte de ce qui s’est passé. Votre ` +
            'téléphone, lui, continue de vous prévenir tout de suite. Une alerte urgente passe ' +
            'outre et vous est envoyée sur-le-champ.',
        emailHeure: 'Résumé envoyé à',
        conges: 'Congés scolaires',
        congesAide: 'D’où votre calendrier tient les dates de vacances. Le calendrier officiel couvre la ' +
            'France métropolitaine ; un fichier .ics prend le relais pour l’outre-mer, une école à ' +
            'l’étranger ou un établissement qui fixe ses propres dates.',
        congesPartage: 'Ce choix vaut pour le dossier : l’autre parent voit le même calendrier.',
        congesOfficiel: 'Calendrier officiel',
        congesOfficielZone: (zone) => `Zone ${zone}, déduite du code postal de l’école.`,
        congesOfficielSansZone: 'Aucune zone déduite : renseignez le code postal de l’école dans la fiche de l’enfant, ' +
            'ou déposez un fichier.',
        congesFichier: 'Fichier déposé',
        congesFichierAide: 'Un fichier .ics exporté de l’agenda de l’école. Il est lu à l’arrivée, puis n’est pas ' +
            'conservé : seules ses dates le sont.',
        congesDeposer: 'Choisir un fichier .ics',
        congesDepotEnCours: 'Lecture du fichier…',
        congesDepot: (nom, periodes) => `${nom} · ${periodes} période${periodes > 1 ? 's' : ''}`,
        congesCouverture: (debut, fin) => `Du ${debut} au ${fin}.`,
        congesRetirer: 'Retirer ce fichier',
        congesErreur: 'Ce fichier n’a pas pu être lu',
        congesAucunDossier: 'Vous n’avez encore aucun dossier à régler.',
        congesMemes: 'Congés des enfants',
        congesMemesOui: 'Les mêmes pour tous',
        congesMemesNon: 'Un réglage par enfant',
        congesMemesAide: 'Un collège et un lycée de part et d’autre d’une limite d’académie suffisent à séparer ' +
            'une fratrie. Chaque enfant part alors du calendrier officiel de SON école, et le ' +
            'calendrier encadre ses jours de sa couleur.',
        congesEnfant: (prenom) => `Congés de ${prenom}`,
    },
    dates: {
        mois: [
            'janvier',
            'février',
            'mars',
            'avril',
            'mai',
            'juin',
            'juillet',
            'août',
            'septembre',
            'octobre',
            'novembre',
            'décembre',
        ],
        jour: 'Jour',
        moisLabel: 'Mois',
        annee: 'Année',
    },
    creerDossier: {
        titre: 'Créer un dossier',
        etapeSur4: (etape) => `Étape ${etape} sur 4`,
        erreurEtape: 'Cette étape n’a pas abouti',
        jalon: { enfants: 'Enfants', garde: 'Garde', invitation: 'Invitation', pret: 'Prêt' },
        etatJalon: { termine: 'terminée', enCours: 'en cours', aVenir: 'à venir' },
        etape1: {
            titreCarte: 'Vos enfants',
            aideFratrie: 'Un dossier réunit les enfants que vous avez avec un même autre parent. Pour ajouter un frère ou une sœur à un dossier existant, ouvrez-le et allez à « Enfants ».',
            prenom: 'Prénom',
            dateNaissance: 'Date de naissance',
            suffixeRang: (index) => ` de l'enfant ${index + 1}`,
            enfantParDefaut: (index) => `Enfant ${index + 1}`,
            retirer: 'Retirer',
            retirerSuffixe: (index, prenom) => ` l’enfant ${index + 1}${prenom ? `, ${prenom}` : ''}`,
            ajouter: 'Ajouter un autre enfant',
            continuer: 'Continuer',
        },
        etape2: {
            titreCarte: 'Le schéma de garde',
            aideModification: "Vous pourrez le modifier plus tard — toute modification demandera l'accord de l'autre parent.",
            schema: 'Schéma',
            nidation: 'En nidation',
            nidationAide: "L'enfant reste au logement familial et ce sont les parents qui alternent. Le partage du temps reste celui du schéma choisi.",
            dateDebut: 'Date de début',
            heure: 'Heure du passage de bras',
            heureAide: "Souvent la sortie d'école.",
            quiCommence: 'Qui commence',
            moi: 'Moi',
            autreParent: "L'autre parent",
            revenir: 'Revenir',
            creer: 'Créer le dossier',
            creationEnCours: 'Création en cours…',
        },
        etape3: {
            titreCarte: 'Inviter l’autre parent',
            intro: "Repère protège les deux parents de la même façon : l'autre parent aura exactement les mêmes droits que vous sur ce dossier, et aucun des deux ne peut en retirer quoi que ce soit.",
            redaction: "Le message est rédigé par Repère, sur un ton neutre. Vous n'avez rien à écrire.",
            email: "Adresse e-mail de l'autre parent",
            plusTard: 'Plus tard',
            envoyer: 'Envoyer l’invitation',
            envoiEnCours: 'Envoi en cours…',
        },
        etape4: {
            titreCarte: 'Votre dossier est prêt',
            messageAvecInvitation: "L'invitation est partie. Le dossier est utilisable dès maintenant, sans attendre de réponse.",
            messageSansInvitation: "Le dossier est utilisable dès maintenant. Vous pourrez inviter l'autre parent quand vous le souhaiterez.",
            ouvrir: 'Ouvrir le dossier',
        },
        residence: {
            pays: "Pays de résidence de l'enfant",
            ville: "Ville de résidence de l'enfant",
            zone: (zone) => `Zone de vacances scolaires ${zone}.`,
            zoneInconnue: "Zone non reconnue — l'orthographe exacte de la commune aide à la retrouver.",
        },
    },
    entree: {
        presentation: {
            accrocheCourte: 'Le calendrier de garde, les échanges et les documents de vos enfants, réunis au même endroit.',
            accrocheLongue: "Repère est l'outil des parents séparés : le calendrier de garde, les échanges et les documents de vos enfants, réunis au même endroit.",
            publics: "Il s'adresse aux deux parents, quel que soit le mode de garde et quel que soit l'état de vos relations. Un avocat, un médiateur ou un travailleur social peut y être invité en lecture, si l'un de vous le décide.",
            garanties: "Tout y est horodaté par nos serveurs, et rien ne peut plus y être modifié ni supprimé — ni par vous, ni par l'autre parent, ni par notre équipe. Chacun dispose exactement des mêmes droits et voit exactement la même chose.",
        },
        modesAcces: {
            titre: 'Vous avez reçu une invitation ?',
            autreParentTitre: "Vous êtes l'autre parent",
            autreParentTexte: "Rejoindre le dossier est gratuit : l'inscription et le calendrier ne demandent aucun abonnement. Chacun souscrit ensuite le sien s'il le souhaite — 9,90 € par mois — et personne ne peut couper l'accès de l'autre.",
            proTitre: 'Vous êtes avocat, médiateur ou travailleur social',
            proTexte: "Votre compte est gratuit, sans limite de dossiers. Vous accédez en lecture à ce qu'un parent vous ouvre, pour la durée qu'il décide. L'autre parent est informé de votre arrivée : personne n'entre dans un dossier à l'insu de quelqu'un.",
        },
        fournisseurs: {
            indisponible: 'Bientôt disponible',
            separateurOu: 'ou',
            intro: 'Avec un compte que vous avez déjà — sans nouveau mot de passe à retenir.',
            redirection: (nom) => `Redirection vers ${nom}…`,
            verbeAvec: (verbe, nom) => `${verbe} avec ${nom}`,
            indisponibleDetail: "Bientôt disponible. L'adresse e-mail et le mot de passe donnent accès à tout le produit : aucune fonctionnalité ne dépendra jamais d'un compte tiers.",
        },
        feuille: {
            fermer: 'Fermer',
        },
        connexion: {
            titre: 'Se connecter',
            verbe: 'Se connecter',
            pasDeCompte: "Vous n'avez pas encore de compte ?",
            sInscrire: "S'inscrire",
            email: 'Adresse e-mail',
            motDePasse: 'Mot de passe',
            motDePasseOublie: 'Mot de passe oublié ?',
            connexionEnCours: 'Connexion en cours…',
            erreurTitre: 'Connexion impossible',
            echecRefus: 'La connexion a été interrompue. Vous pouvez réessayer, ou entrer votre adresse et votre mot de passe.',
            echecExpire: 'La connexion a pris trop de temps. Réessayez.',
            echecGenerique: "La connexion par ce fournisseur n'a pas abouti. Vous pouvez entrer votre adresse et votre mot de passe.",
        },
        inscription: {
            titre: 'Créer un compte',
            verbe: "S'inscrire",
            motDePasseTropCourt: 'Le mot de passe doit faire au moins 12 caractères.',
            verifiezBoite: 'Vérifiez votre boîte e-mail',
            siAdresseUtilisable: "Si cette adresse peut être utilisée, un message vient d'y être envoyé. Ouvrez le lien qu'il contient pour confirmer votre adresse.",
            dejaConnexionPossible: 'Vous pouvez déjà vous connecter : la confirmation peut attendre.',
            dejaCompte: 'Vous avez déjà un compte ?',
            seConnecter: 'Se connecter',
            prenom: 'Prénom',
            prenomAide: "Affiché à l'autre parent.",
            email: 'Adresse e-mail',
            motDePasse: 'Mot de passe',
            motDePasseAide: 'Au moins 12 caractères. Une phrase dont vous vous souvenez fait un bon mot de passe.',
            erreurTitre: 'Création impossible',
            creationEnCours: 'Création en cours…',
            creerMonCompte: 'Créer mon compte',
            echecGenerique: "Quelque chose n'a pas fonctionné. Réessayez dans un instant.",
        },
    },
    dossier: {
        categories: {
            aujourdhui: "Aujourd'hui",
            calendrier: 'Calendrier',
            messages: 'Messages',
            depenses: 'Dépenses',
            journal: 'Journal',
            enfants: 'Enfants',
        },
        navigation: {
            ariaCategories: 'Catégories du dossier',
            reserveParent: 'Réservé aux formules Solo et Duo. Ce qui est déjà enregistré reste lisible.',
            reserveParentSuffixe: ', réservé aux formules Solo et Duo',
            nouveaute: (n) => accorder('fr', n, { one: '1 nouveauté', other: `${n} nouveautés` }),
        },
        calendrier: {
            moisPrecedent: 'Mois précédent',
            moisSuivant: 'Mois suivant',
            erreurChargement: 'Le calendrier n’a pas pu être chargé',
            titre: (moisEtAnnee) => `Calendrier de garde — ${moisEtAnnee}`,
            chezVous: 'Chez vous',
            chezAutre: (nom) => `Chez ${nom}`,
            nonDefini: 'non défini',
            libelleEchange: 'échange de jours',
            libelleDerogation: 'dérogation convenue',
            titreEchange: 'Échange de jours convenu',
            titreDerogationConvenue: 'Dérogation convenue',
            avecMotif: (base, motif) => `${base} — ${motif}`,
            suffixeDerogation: (libelle) => `, ${libelle}`,
            suffixeMotif: (motif) => `, motif : ${motif}`,
            marqueEchange: 'Échangé',
            legendeEchange: "Jour échangé d'un commun accord",
            suffixeConge: ' — vacances scolaires',
            suffixeCongeEnfants: (prenoms) => ` — vacances scolaires : ${prenoms}`,
            legendeConge: (zone) => `Vacances scolaires · zone ${zone}`,
            legendeCongeFichier: 'Vacances scolaires · fichier déposé',
            legendeCongeEnfant: (prenom, source) => `${prenom} — ${source}`,
            legendeCongesAbsents: 'Vacances scolaires : rien à afficher. Renseignez le code postal de l’école dans la ' +
                'fiche de l’enfant, ou déposez un fichier de congés depuis Mon compte › Options.',
        },
        journal: {
            ariaFiltrer: 'Filtrer le journal',
            filtreTout: 'Tout',
            filtrePartagees: 'Partagées',
            filtrePrivees: 'Privées',
            entreeSuffixe: (n) => accorder('fr', n, { one: ', 1 entrée', other: `, ${n} entrées` }),
            erreurChargement: 'Le journal n’a pas pu être chargé',
            modeSoloTexte: "Vous êtes seul sur ce dossier pour l'instant, et le journal fonctionne normalement. Si l'autre parent rejoint plus tard, il verra les entrées que vous aurez marquées comme partagées, avec leur date d'origine.",
            videTout: 'Aucune entrée pour l’instant.',
            videPartagees: 'Aucune entrée partagée.',
            videPrivees: 'Aucune entrée privée.',
            auteurVous: 'Vous',
            auteurAutreParent: "L'autre parent",
            marquePrivee: 'Privée',
            marquePartagee: 'Partagée',
            invisibleSuffixePrivee: 'Entrée privée, visible de vous seul, inaltérable.',
            invisibleSuffixePartagee: "Entrée partagée avec l'autre parent, inaltérable.",
            mentionImmuable: "Chaque entrée est horodatée par nos serveurs et ne peut plus être modifiée ni supprimée — ni par vous, ni par l'autre parent, ni par notre équipe. Notez des faits : ce qui a eu lieu, quand.",
            mentionImmuableBouton: 'Immutabilité du journal',
            labelFait: 'Le fait à consigner',
            placeholderFait: 'Le fait à consigner — « Échange effectué à 18h05 »',
            ariaQuiPeutVoir: 'Qui peut voir cette entrée ?',
            intituleVisiblePar: 'Visible par',
            visibiliteAutre: "L'autre parent",
            visibiliteAutreAide: "Elle apparaît dans le journal des deux parents, à l'identique.",
            visibiliteMoi: 'Vous seul',
            visibiliteMoiAide: "L'autre parent n'en est pas informé. Elle ne figurera que dans votre propre export.",
            aideChoixDefaut: "Choisissez qui verra cette entrée : rien n'est coché d'avance.",
            enregistrementEnCours: 'Enregistrement…',
            consigner: 'Consigner',
            erreurEnregistrement: 'L’entrée n’a pas pu être enregistrée',
            reformuler: 'Reformule ce texte pour moi',
            reformulationEnCours: 'Reformulation…',
            reformulationTitre: 'Une autre façon de le dire',
            reformulationAide: 'Rien n’est conservé : ni votre brouillon, ni cette proposition — personne ne ' +
                'saura que vous l’avez demandée.',
            reformulationUtiliser: 'Utiliser cette version',
            reformulationGarder: 'Garder mon texte',
            reformulationDejaNeutre: 'Votre texte est déjà factuel : il n’y a rien à adoucir.',
            reformulationIndisponible: 'La reformulation n’est pas disponible pour l’instant. Vous pouvez consigner votre texte tel quel.',
            reformulationBudget: 'Vous avez utilisé vos reformulations du jour. Elles reviennent demain.',
            reformulationTropLong: 'Ce texte est trop long pour être reformulé.',
        },
        depenses: {
            statutAttente: 'En attente de réponse',
            statutAcceptee: 'Acceptée',
            statutContestee: 'Contestée',
            statutRemboursee: 'Remboursée',
            categories: ['santé', 'scolarité', 'cantine', 'activités', 'vêtements', 'transport'],
            comptesAJour: 'Les comptes sont à jour.',
            soldePhrase: (debiteur, jeSuisDebiteur, montant, crediteur) => `${debiteur} ${jeSuisDebiteur ? 'devez' : 'doit'} ${montant} à ${crediteur}.`,
            detailLigneALigne: 'Le détail, ligne à ligne',
            ligneDetail: (date, categorie, montant, payeur, montantAutre) => `${date} — ${categorie} : ${montant} avancés par ${payeur}, dont ${montantAutre} à la charge de l'autre.`,
            soldeNonStocke: "Ce solde n'est stocké nulle part : il est recalculé à chaque affichage depuis ces lignes. Vous pouvez refaire l'addition.",
            sansRegleTitre: 'Des dépenses attendent une clé de répartition',
            sansRegleTexte: (n) => accorder('fr', n, {
                one: '1 dépense est antérieure à toute clé et n’est pas comptée.',
                other: `${n} dépenses sont antérieures à toute clé et ne sont pas comptées.`,
            }),
            erreurChargement: 'Les dépenses n’ont pas pu être chargées',
            declarerUneDepense: 'Déclarer une dépense',
            justificatifAnalyse: 'Analysé, chiffré, et joint aux documents du dossier.',
            lectureTitre: 'Lire le justificatif à votre place ?',
            lectureQuestion: 'Repère peut lire la photo de votre ticket et vous proposer le montant, la date et ' +
                'la catégorie. Vous relisez, vous corrigez, vous validez.',
            lectureDetail: 'La photo est envoyée à Mistral, notre prestataire d’IA européen, à cette seule fin. ' +
                'Elle n’y est pas conservée, et nous n’en gardons rien non plus. C’est la seule ' +
                'donnée de votre dossier qui sorte de nos serveurs — vous pouvez revenir sur cet ' +
                'accord à tout moment dans « Options ».',
            lectureAccepter: 'Oui, lire mes justificatifs',
            lectureRefuser: 'Non, je saisis moi-même',
            lectureEnCours: 'Lecture du justificatif…',
            lectureProposee: 'Montant, date, catégorie et commentaire proposés d’après le justificatif. Relisez-les.',
            commentaire: 'Commentaire',
            commentairePlaceholder: 'Pharmacie du Centre — antibiotiques et pansements',
            commentaireAide: 'Facultatif. Ce que dit le ticket : le commerce, ce qui a été acheté. La lecture du ' +
                'justificatif peut le proposer, vous le relisez.',
            lectureRien: 'Rien n’a pu être lu sur cette photo. Saisissez la dépense à la main.',
            lectureIndisponible: 'La lecture n’est pas disponible pour l’instant. Saisissez la dépense à la main.',
            lectureBudget: 'Vous avez utilisé vos lectures du jour. Elles reviennent demain.',
            lectureQuota: 'Ce dossier a utilisé ses cinq lectures du jour. Elles reviennent demain.',
            retirer: 'Retirer',
            photographierLeTicket: 'Photographier le ticket',
            choisirUnFichier: 'Choisir un fichier',
            envoiEnCours: 'Envoi en cours…',
            justificatifAide: "Facultatif, mais c'est lui qui tranche si la dépense est contestée. PDF ou photo.",
            erreurJustificatif: 'Le justificatif n’a pas pu être joint',
            montant: 'Montant',
            montantInvalide: 'Montant invalide.',
            dateDeLaDepense: 'Date de la dépense',
            ariaCategorie: 'Catégorie de la dépense',
            erreurDeclaration: 'La dépense n’a pas pu être enregistrée',
            enregistrementEnCours: 'Enregistrement…',
            declarerLaDepense: 'Déclarer la dépense',
            aideAvecCategorie: 'La date choisie détermine la clé de répartition appliquée.',
            aideSansCategorie: "Choisissez une catégorie : rien n'est pré-réglé.",
            unParent: 'Un parent',
            vous: 'Vous',
            justificatifJoint: 'Justificatif joint',
            avancePar: (date, payeur) => `${date} · avancé par ${payeur}`,
            accepter: 'Accepter',
            motifSiConteste: 'Motif, si vous contestez',
            motifAide: 'Un désaccord sans motif n’avance à rien : dites ce qui pose problème.',
            contester: 'Contester',
            videListe: "Aucune dépense pour l'instant.",
            ongletDetail: 'Détail',
            ongletPartagees: 'Dépenses partagées',
        },
        messagerie: {
            ariaFils: 'Fils de discussion',
            filTous: 'Tous',
            filSansFil: 'Sans fil',
            filSante: 'Santé',
            filEcole: 'École',
            filVacances: 'Vacances',
            filUrgences: 'Urgences',
            messageSuffixe: (n) => accorder('fr', n, { one: ', 1 message', other: `, ${n} messages` }),
            erreurChargement: 'Les messages n’ont pas pu être chargés',
            ouvrirLaPieceJointe: 'Ouvrir la pièce jointe',
            erreurOuverturePiece: 'La pièce jointe n’a pas pu être ouverte',
            pieceJointeScellee: 'Scellée(s) avec le message : la remplacer casserait son empreinte.',
            redactionPieceScellee: (nomFichier) => `${nomFichier} — analysé, chiffré, et son empreinte scellée avec le message : le remplacer ensuite casserait la chaîne.`,
            videAucun: "Aucun message pour l'instant.",
            videAucunDansCeFil: 'Aucun message dans ce fil.',
            nouveauxMessages: (n) => accorder('fr', n, { one: '1 nouveau message', other: `${n} nouveaux messages` }),
            vosEnvoisDifferes: 'Vos envois différés',
            envoisDifferesAide: 'Visibles de vous seul tant qu’ils ne sont pas partis. Vous pouvez encore les annuler.',
            envoiPrevu: (corps, date, heureTexte) => `« ${corps} » — envoi prévu le ${date} à ${heureTexte}`,
            annulerCetEnvoi: 'Annuler cet envoi',
            retirer: 'Retirer',
            mentionImmuable: "Les messages échangés ici ne peuvent être ni modifiés ni supprimés — ni par vous, ni par l'autre parent, ni par notre équipe. Chacun est horodaté par nos serveurs.",
            mentionImmuableBouton: 'Immutabilité des messages',
            reformuler: 'Reformule ce message pour moi',
            reformulationEnCours: 'Reformulation…',
            reformulationTitre: 'Une autre façon de le dire',
            reformulationAide: 'Rien n’a été envoyé, et rien n’est conservé : ni votre brouillon, ni cette ' +
                'proposition. L’autre parent ne saura pas que vous l’avez demandée.',
            reformulationUtiliser: 'Utiliser cette version',
            reformulationGarder: 'Garder mon texte',
            reformulationDejaNeutre: 'Votre message est déjà factuel : il n’y a rien à adoucir.',
            reformulationIndisponible: 'La reformulation n’est pas disponible pour l’instant. Votre message part inchangé.',
            reformulationBudget: 'Vous avez utilisé vos reformulations du jour. Elles reviennent demain.',
            reformulationTropLong: 'Ce message est trop long pour être reformulé.',
            votreMessage: 'Votre message',
            placeholderEcrire: 'Écrire un message…',
            joindreUnDocument: 'Joindre un document',
            envoyerPlusTard: 'Envoyer plus tard',
            envoiEnCours: 'Envoi en cours…',
            programmerLEnvoi: 'Programmer l’envoi',
            envoyer: 'Envoyer',
            dateEtHeureEnvoi: "Date et heure d'envoi",
            aideHorodatage: "L'horodatage qui fera foi sera celui de l'envoi.",
            erreurEnvoi: 'Le message n’a pas pu être envoyé',
            inactiveTexte: "La messagerie s'activera lorsque l'autre parent aura rejoint le dossier : elle n'a pas d'objet sans interlocuteur.",
            auteurVous: 'Vous',
            auteurAutreParent: "L'autre parent",
            messageInvisible: (date, heureTexte, numero) => `${date} à ${heureTexte}. Message numéro ${numero}, inaltérable.`,
        },
        suppression: {
            ouvrir: 'Supprimer ce dossier',
            titre: 'Supprimer ce dossier',
            texte: "La suppression se décide à deux : l'autre parent recevra un message et devra la " +
                'valider. Une fois validée, le dossier reste consultable trente jours sans pouvoir ' +
                "être modifié, puis il est détruit définitivement. Pendant ce délai, l'un comme " +
                "l'autre peut tout annuler.",
            texteSolo: 'Vous êtes seul sur ce dossier : le message de validation vous sera adressé. Une ' +
                'fois validée, la suppression laisse le dossier consultable trente jours sans ' +
                'pouvoir être modifié, puis il est détruit définitivement. Vous pouvez tout annuler ' +
                "jusqu'au dernier jour.",
            demander: 'Demander la suppression',
            envoiEnCours: 'Envoi en cours…',
            erreur: "La demande n'a pas pu être envoyée",
            renoncer: 'Ne pas supprimer',
            attenteAutre: "La suppression de ce dossier a été demandée. L'autre parent a reçu un message : " +
                "elle ne prendra effet que s'il la valide.",
            attenteVous: 'La suppression de ce dossier a été demandée. Vous avez reçu un message : ouvrez-le ' +
                'pour la valider ou la refuser.',
            attenteEcheance: (date) => `Sans réponse, cette demande s'annulera d'elle-même le ${date}.`,
            archiveTitre: 'Dossier archivé',
            archiveTexte: (date) => `Ce dossier sera détruit définitivement le ${date}.`,
            archiveLecture: 'Il reste consultable jusque-là — vous pouvez le relire et en demander un export — ' +
                'mais plus personne ne peut y écrire.',
            annuler: 'Annuler la suppression',
            annulationEnCours: 'Annulation…',
        },
        ecran: {
            modeSolo: `Vous utilisez ce dossier seul`,
            modePartage: `Dossier partagé · droits identiques`,
            modePartageAvec: (prenom) => `Partagé avec ${prenom} · droits identiques`,
            quiALEnfant: `Qui a l’enfant ?`,
            quiReponseVous: `L’enfant est chez vous`,
            quiReponseAutre: (prenom) => `L’enfant est chez ${prenom}`,
            quiAucunSchema: `Aucun schéma de garde ne couvre cette date`,
            quiDerogation: `Par dérogation convenue.`,
            quiRecherche: `Recherche…`,
            quiErreur: `La réponse n’a pas pu être obtenue`,
            quiDateAujourdhui: (date) => `Aujourd’hui, ${date}`,
            quiQuelleDate: `À quelle date ?`,
            quiAutreJour: `Voir un autre jour`,
            quiRevenirAujourdhui: `Revenir à aujourd’hui`,
            demandesAccord: `Demandes d’accord`,
            ongletNouveautes: `Nouveautés`,
            ongletDossier: `Le dossier`,
            modeSoloTexte: `Le calendrier, le journal et les documents fonctionnent normalement. Tout ce que vous y enregistrez est horodaté dès maintenant.`,
            invitationEnvoyeeTexte: `Une invitation a été envoyée. Elle reste valable 30 jours.`,
            renvoyerOuCorriger: `Renvoyer ou corriger l’adresse`,
            nouvelleAdresseRemplace: `La nouvelle adresse remplace la précédente : le lien déjà envoyé cesse d’être valable.`,
            peutInviterQuandVeut: `Vous pouvez inviter l'autre parent quand vous le souhaitez.`,
            erreurInvitation: `L’invitation n’a pas pu être envoyée`,
            emailAutreParent: `Adresse e-mail de l'autre parent`,
            aideInvitation: `Le message est rédigé par Repère, sur un ton neutre.`,
            envoiEnCours: `Envoi en cours…`,
            envoyerInvitation: `Envoyer l’invitation`,
            calendrierDeGarde: `Le calendrier de garde`,
            demanderEchange: `Demander un échange de jours`,
            historiqueSchema: `Historique du schéma de garde`,
            depensesPartagees: `Dépenses partagées`,
            ficheDe: (prenom) => `Fiche de ${prenom}`,
        },
    },
    schemasDeGarde: {
        schemas: {
            alternating_week: {
                libelle: 'Semaine alternée (7/7)',
                detail: 'Une semaine chez l’un, une semaine chez l’autre. Le schéma le plus répandu.',
            },
            two_two_five_five: {
                libelle: '2-2-5-5',
                detail: 'Deux jours fixes chez chacun chaque semaine, puis cinq jours incluant le week-end.',
            },
            two_two_three: {
                libelle: '2-2-3',
                detail: 'Deux nuits, deux nuits, trois nuits : pensé pour les enfants jeunes.',
            },
            three_four_four_three: {
                libelle: '3-4-4-3',
                detail: 'Bascule en milieu de semaine, sur un cycle de deux semaines.',
            },
            fortnight: {
                libelle: 'Quinzaine alternée (14/14)',
                detail: 'Deux semaines chez chacun : adolescents, ou éloignement géographique.',
            },
            nine_five: {
                libelle: 'Alternance 9/5',
                detail: 'Neuf nuits chez l’un, cinq chez l’autre, sur un cycle de deux semaines.',
            },
            ten_four: {
                libelle: 'Alternance 10/4',
                detail: 'Dix nuits chez l’un, quatre chez l’autre, sur un cycle de deux semaines.',
            },
            alternate_weekends: {
                libelle: 'Week-ends alternés (1er, 3e, 5e)',
                detail: 'Droit de visite et d’hébergement classique : un week-end sur deux, vendredi à dimanche.',
            },
            extended_weekends: {
                libelle: 'Week-ends alternés élargis',
                detail: 'Droit de visite élargi : un week-end sur deux, du vendredi soir au lundi matin.',
            },
            visits_only: {
                libelle: 'Visites sans hébergement',
                detail: 'Droit de visite réduit : des journées, sans nuitée. Chaque visite est posée au calendrier.',
            },
            holidays_only: {
                libelle: 'Vacances scolaires uniquement',
                detail: 'Droit de visite longue distance : pas de week-ends réguliers, l’essentiel des vacances.',
            },
            third_party: {
                libelle: 'Résidence chez un tiers',
                detail: 'L’enfant réside chez un tiers ; les temps de chaque parent sont posés un à un.',
            },
            custom: {
                libelle: 'Sur mesure',
                detail: 'Aucune génération automatique : le calendrier se construit période par période.',
            },
        },
        familles: {
            alternance: 'Résidence alternée',
            alternance_inegale: 'Résidence alternée inégalitaire',
            residence_principale: 'Résidence principale chez un parent',
            autre: 'Autre',
        },
    },
    apercu: {
        titre: "Aperçu de l'alternance",
        pasDeCycle: (libelle) => `« ${libelle} » n'a pas de cycle à dérouler : les temps de chacun se posent période par période, dans le calendrier du dossier. Il n'y a donc rien à prévisualiser ici.`,
        choisirDate: "Choisissez une date de début : l'aperçu montrera alors les trois premiers mois, jour par jour.",
        aPartirDu: (date) => `À partir du ${date} :`,
        joursChezVous: (n) => accorder('fr', n, { one: '1 jour chez vous', other: `${n} jours chez vous` }),
        etJoursChezAutre: (n) => `et ${n} chez l'autre parent, sur les trois mois affichés.`,
        chezVousInvisible: ', chez vous',
        chezAutreInvisible: ", chez l'autre parent",
        legendeChezVous: 'Chez vous',
        legendeChezAutre: "Chez l'autre parent",
        legendePassage: 'Passage de bras',
    },
    site: {
        nav: {
            accueil: 'Accueil',
            tarifs: 'Tarifs',
            connexion: 'Se connecter',
            inscription: 'S’inscrire',
        },
        footer: {
            accroche: 'Organisation et sérénité pour les parents séparés. Hébergement en France, aucun traceur, aucun cookie tiers.',
            produit: 'Produit',
            tarifsLien: 'Tarifs',
            applicationsLien: 'Applications mobiles',
            legal: 'Légal',
            mentionsLegales: 'Mentions légales',
            confidentialite: 'Politique de confidentialité',
            pied: (annee) => `Repère-kids — ${annee}. Hébergé en France.`,
            version: (version, horodatage) => `Version ${version} — build du ${horodatage}`,
        },
        accueil: {
            titre: 'Coordination des parents séparés',
            description: 'Repère : calendrier de garde, dépenses partagées, messagerie horodatée et historique inaltérable pour les parents séparés.',
            badgeConfiance: 'Hébergé en France · Aucun traceur',
            h1: 'La coordination, sans que chaque échange devienne une négociation.',
            accroche: "Un calendrier de garde, des dépenses partagées, des documents, des échanges — et une trace horodatée que ni l'un ni l'autre parent ne peut réécrire.",
            etrePrevenu: 'Être prévenu du lancement',
            pointChiffre: 'Chiffré par dossier',
            pointServeurs: 'Serveurs en France',
            pointHistorique: 'Historique inaltérable',
            question: 'Qui a les enfants mercredi ?',
            reponseForte: 'Mercredi 16 septembre — chez vous',
            reponseSuite: 'Prochain passage de bras : vendredi 18, 16 h 30',
            moisCarte: 'Septembre 2026',
            legendeChezVous: 'Chez vous',
            legendeChezAutre: "Chez l'autre parent",
            captureAlt: "Copie d'écran de Repère-kids : le calendrier de garde d'un dossier partagé, en août 2026.",
            captureLegende: "L'application, vue calendrier. Données fictives.",
            surTitreChange: 'Ce que Repère change',
            titreChange: "Trois questions qui n'ont plus à se discuter",
            introChange: "Le calendrier, les accords et l'historique — chacun tranché une fois, par le produit, pas par vous.",
            carte1Titre: 'Un calendrier qui répond tout de suite',
            carte1Texte: "Qui a l'enfant mercredi ? La réponse est à l'écran, pour aujourd'hui comme pour n'importe quelle date.",
            carte2Titre: 'Des accords datés',
            carte2Texte: "Un échange de jours se propose, s'accepte ou se décline. Chaque étape est enregistrée, personne n'a à se souvenir de qui a dit quoi.",
            carte3Titre: "Un historique qui n'appartient à personne",
            carte3Texte: "Ni vous, ni l'autre parent, ni notre support ne peut modifier ou supprimer ce qui a été partagé.",
            surTitreParti: 'Parti pris',
            titreParti: 'Conçu pour ne pas devenir une arme',
            texteParti: "Repère enregistre des faits ; il ne les interprète pas et ne les met pas en scène. Les deux parents ont exactement les mêmes droits — aucun des deux ne peut exclure l'autre, ni retirer quoi que ce soit de l'historique commun.",
            absencesIntitule: 'Ce que vous ne trouverez pas ici',
            // guardrail-ok: liste « ce que vous ne trouverez pas ici » — le libellé annonce l'absence du mécanisme
            absence1: 'Accusé de lecture',
            // guardrail-ok: liste « ce que vous ne trouverez pas ici » — le libellé annonce l'absence du mécanisme
            absence2: 'Statut « en ligne », « vu à », « dernière connexion »',
            absence3: 'Compteur de retards, score de comportement',
            absence4: 'Compte « propriétaire » du dossier',
            surTitreAcces: "Modalités d'accès",
            titreAcces: 'Vous avez reçu une invitation ?',
            introAcces: 'La question se pose avant de créer un compte, alors la réponse vient avant le formulaire.',
            acces1Titre: "Vous êtes l'autre parent",
            acces1Texte: "Rejoindre le dossier est gratuit : l'inscription et le calendrier ne demandent aucun abonnement. Chacun souscrit ensuite le sien s'il le souhaite — 9,90 € par mois — et personne ne peut couper l'accès de l'autre.",
            acces1Badge: 'Gratuit',
            acces2Titre: 'Vous êtes avocat, médiateur ou travailleur social',
            acces2Texte: "Votre compte est gratuit, sans limite de dossiers. Vous accédez en lecture à ce qu'un parent vous ouvre, pour la durée qu'il décide. L'autre parent est informé de votre arrivée : personne n'entre dans un dossier à l'insu de quelqu'un.",
            acces2Badge: 'Gratuit, illimité',
            acces3Titre: 'Vous découvrez sans rien avoir reçu',
            acces3Texte: "Inscrivez-vous à la liste d'attente pour être prévenu dès l'ouverture. Vous ne créez un dossier que si vous décidez d'inviter l'autre parent.",
            acces3Badge: 'Sans compte',
            surTitreTarifs: 'Tarifs',
            titreTarifs: "Un abonnement par parent. Rien d'autre.",
            introTarifs: "Pas de version « premium » qui débloque des droits sur l'autre : les deux parents voient la même chose, quel que soit leur abonnement.",
            basculeLegende: 'Fréquence de facturation',
            basculeMensuel: 'Mensuel',
            basculeAnnuel: 'Annuel',
            tarifRejoindreTitre: 'Link',
            tarifRejoindrePrix: '0 €',
            tarifRejoindreTexte: 'Pour le parent invité à rejoindre un dossier existant.',
            tarifRejoindreAvantage1: 'Calendrier de garde partagé',
            tarifRejoindreAvantage2: "Lecture complète de l'historique",
            tarifRejoindreAvantage3: 'Aucune date limite',
            tarifParentTitre: 'Solo',
            tarifParentEtiquette: 'Le plus courant',
            tarifParentPrixMensuel: '9,90 € / mois, par parent',
            tarifParentPrixMensuelDuo: '14,90 € / mois, pour les deux parents',
            tarifParentPrixAnnuelSeul: '99 € / an, par parent',
            tarifParentPrixAnnuelDuo: '149 € / an, pour les deux parents',
            tarifParentPrixAnnuel: 'Deux mois offerts par rapport au mensuel.',
            tarifParentEssaiGratuit: 'Essai gratuit de 7 jours',
            tarifParentBoutonNotification: 'Réserver mon accès « Early bird »',
            tarifParentSwitchDuo: "Inclure l'autre parent",
            tarifParentEarlybirdEtiquette: 'Early bird',
            tarifParentEarlybirdTexte: "79 € la première année pour les inscrits à la liste d'attente, puis tarif annuel.",
            tarifParentEarlybirdTexteDuo: "129 € la première année pour les inscrits à la liste d'attente, puis tarif annuel.",
            tarifParentEngagement: 'Sans engagement au mois. Résiliable en un clic depuis votre compte.',
            tarifParentOptionDeuxEtiquette: 'Duo',
            tarifParentOptionDeuxTexte: "+ 5 € par mois, soit 14,90 € au total, pour couvrir aussi l'abonnement de l'autre parent.",
            tarifParentOptionDeuxTexteAnnuel: "+ 50 € par an, soit 149 € au total, pour couvrir aussi l'abonnement de l'autre parent.",
            tarifParentAvantage1: 'Tout ce que Link comprend',
            tarifParentAvantage2: 'Messagerie, dépenses partagées, documents chiffrés',
            tarifParentAvantage3: "Propositions d'échange et journal",
            tarifParentAvantage4: 'Export horodaté du dossier',
            tarifParentAvantage5: "Invitation d'un professionnel en lecture",
            tarifProTitre: 'Pro',
            tarifProPrix: '0 €',
            tarifProTexte: 'Avocat, médiateur familial, travailleur social.',
            tarifProAvantage1: 'Nombre de dossiers illimité',
            tarifProAvantage2: "Accès en lecture, sur invitation d'un parent",
            tarifProAvantage3: "Export d'historique authentifié",
            mentionTarifs: "Prix TTC. Le service n'est pas encore ouvert : les conditions précises — durée d'essai, modalités de résiliation — seront publiées ici à l'ouverture.",
            surTitreMobile: 'Sur le téléphone',
            titreMobile: "Le calendrier dans la poche, l'historique au même endroit",
            texteMobile: "Les applications iOS et Android donnent accès au même dossier que le web : mêmes droits, mêmes données, même historique. Une notification vous prévient d'une proposition d'échange ou d'une alerte urgente — jamais du fait que l'autre parent est connecté.",
            appStore: 'App Store',
            googlePlay: 'Google Play',
            mobileNote: 'Les liens App Store et Google Play seront activés à l’ouverture du service.',
            mobileCalendrierAlt: "Aperçu de l'écran calendrier de l'application mobile.",
            mobileDossiersAlt: "Aperçu de l'écran d'accueil de l'application mobile : la liste des dossiers.",
            mobileLegende: "Aperçus de l'application mobile. Données fictives.",
        },
        waitlist: {
            titre: 'Être prévenu du lancement',
            texte: "Laissez votre adresse : vous recevrez un message à l'ouverture, et rien d'autre. Pas de lettre d'information, pas de relance.",
            labelEmail: 'Adresse e-mail',
            bouton: "M'inscrire",
            aide: 'Utilisée uniquement pour vous prévenir du lancement. Supprimable à tout moment.',
            erreurEmailInvalide: 'Merci de saisir une adresse e-mail valide.',
            envoiEnCours: 'Envoi en cours…',
            succes: 'C’est noté. Vous recevrez un message au lancement.',
            echec: 'L’inscription n’a pas abouti. Réessayez dans quelques instants.',
        },
        confidentialite: {
            titre: 'Politique de confidentialité',
            description: 'Comment Repère traite les données personnelles : hébergement en France, chiffrement, absence de traceurs.',
            avisProvisoire: "Document provisoire, en attente de validation juridique. Il décrit fidèlement le fonctionnement technique du service, mais sa rédaction juridique doit être revue par un conseil avant l'ouverture (voir la feuille de route du projet).",
            miseAJour: (date) => `Dernière mise à jour : ${date}.`,
            siteTitre: 'Ce site',
            siteTexte1: 'Le site ne dépose aucun cookie et n’appelle aucun service tiers.',
            siteTexte2: "Si vous vous inscrivez à la liste d'attente, seule votre adresse e-mail est conservée, avec la page d'où vient l'inscription. Elle sert uniquement à vous prévenir du lancement, et vous pouvez demander sa suppression à tout moment.",
            serviceTitre: 'Le service',
            serviceHebergementTitre: 'Hébergement en France',
            serviceHebergementTexte: ', sauvegardes comprises. Aucun transfert hors de l’Union européenne.',
            serviceChiffrementTitre: 'Chiffrement',
            serviceChiffrementTexte: ': les échanges sont chiffrés en transit ; les contenus sensibles et les documents sont chiffrés au repos, avec une clé propre à chaque dossier de coparentalité.',
            serviceBoutTitre: 'Pas de chiffrement de bout en bout',
            serviceBoutTexte: ', et nous le disons clairement : le service doit pouvoir horodater, sceller et exporter l’historique pour tenir sa promesse. Vos contenus sont déchiffrables par le service, jamais par un tiers.',
            serviceHistoriqueTitre: 'Historique commun conservé',
            serviceHistoriqueTexte: " : la suppression d'un compte anonymise son titulaire mais ne détruit pas l'historique partagé, qui appartient aussi à l'autre parent. C'est une caractéristique essentielle du service, indiquée dès l'inscription.",
            serviceSignatureTitre: 'Preuve indépendante',
            serviceSignatureTexte: " : chaque évènement est signé numériquement au moment de son enregistrement par un tiers indépendant, extérieur à Repère — la même démarche que pour authentifier un document officiel. La preuve que rien n'a été modifié depuis reste vérifiable à tout moment.",
            servicePubTitre: 'Pas de publicité, pas de traceur, pas de revente.',
            servicePubTexte: ' Les journaux techniques ne contiennent pas de données personnelles.',
            droitsTitre: 'Vos droits',
            droitsTexte: "Accès, rectification, portabilité, effacement, limitation et opposition s'exercent auprès du service. L'export du dossier fait aussi office de réponse au droit d'accès. Les coordonnées du délégué à la protection des données seront publiées ici avant l'ouverture du service.",
        },
        mentionsLegales: {
            titre: 'Mentions légales',
            description: 'Mentions légales du site Repère : éditeur, hébergement et propriété intellectuelle.',
            avisProvisoire: "Document provisoire, en attente de validation juridique. Les éléments d'identification de l'éditeur et de l'hébergeur seront complétés avant l'ouverture du service.",
            miseAJour: (date) => `Dernière mise à jour : ${date}.`,
            editeurTitre: 'Éditeur',
            editeurTexte: 'Repère — forme juridique, siège social, numéro d’immatriculation et directeur de la publication à compléter.',
            hebergementTitre: 'Hébergement',
            hebergementTexte: 'Le site et le service sont hébergés en France. Aucune donnée n’est transférée hors de l’Union européenne.',
            contactTitre: 'Contact',
            contactTexte: 'Adresse de contact à compléter.',
            proprieteTitre: 'Propriété intellectuelle',
            proprieteTexte: 'La marque Repère, son logo et le contenu de ce site sont protégés. Toute reproduction sans autorisation est interdite.',
        },
    },
    notifications: {
        libelles: {
            message_new: { un: 'un nouveau message', plusieurs: (n) => `${n} nouveaux messages` },
            proposal_new: {
                un: "une nouvelle demande d'accord",
                plusieurs: (n) => `${n} nouvelles demandes d'accord`,
            },
            proposal_answered: {
                un: "une réponse à une demande d'accord",
                plusieurs: (n) => `${n} réponses à des demandes d'accord`,
            },
            expense_new: { un: 'une nouvelle dépense', plusieurs: (n) => `${n} nouvelles dépenses` },
            document_new: { un: 'un nouveau document', plusieurs: (n) => `${n} nouveaux documents` },
            calendar_event_new: {
                un: 'un nouvel élément au calendrier',
                plusieurs: (n) => `${n} nouveaux éléments au calendrier`,
            },
            alert_new: { un: 'une alerte', plusieurs: (n) => `${n} alertes` },
            professional_invited: {
                un: 'un accès professionnel ouvert',
                plusieurs: (n) => `${n} accès professionnels ouverts`,
            },
            writing_opened: {
                un: "l'écriture ouverte sur un dossier",
                plusieurs: (n) => `l'écriture ouverte sur ${n} dossiers`,
            },
        },
        enumeration: (morceaux) => morceaux.length <= 1
            ? (morceaux[0] ?? '')
            : `${morceaux.slice(0, -1).join(', ')} et ${morceaux.at(-1)}`,
    },
    mail: {
        verification: {
            objet: 'Confirmez votre adresse e-mail',
            texte: (lien) => [
                'Bonjour,',
                '',
                'Pour confirmer votre adresse e-mail sur Repère, ouvrez ce lien :',
                lien,
                '',
                "Ce lien est valable 24 heures. Si vous n'êtes pas à l'origine de cette demande,",
                'vous pouvez ignorer ce message : aucun compte ne sera activé.',
                '',
                'Repère — organisation & sérénité',
            ].join('\n'),
            titre: 'Confirmez votre adresse e-mail',
            paragraphes: [
                'Bonjour,',
                'Pour confirmer votre adresse e-mail sur Repère, utilisez le bouton ci-dessous.',
            ],
            bouton: 'Confirmer mon adresse',
            note: "Ce lien est valable 24 heures. Si vous n'êtes pas à l'origine de cette demande, vous pouvez ignorer ce message : aucun compte ne sera activé.",
        },
        invitationDossier: {
            objet: 'Vous êtes invité à rejoindre un dossier sur Repère',
            texte: (inviterName, lien) => [
                'Bonjour,',
                '',
                `${inviterName} utilise Repère pour organiser le quotidien de vos enfants`,
                'et vous propose de rejoindre le dossier.',
                '',
                'Repère protège les deux parents de la même façon : vous y aurez exactement les',
                "mêmes droits, et l'historique n'appartient à aucun des deux. Personne ne peut",
                'en retirer quoi que ce soit, ni vous en exclure.',
                '',
                'Pour rejoindre le dossier :',
                lien,
                '',
                "Ce lien est valable 30 jours. Si vous préférez ne pas l'utiliser, vous pouvez",
                'ignorer ce message : rien ne se passera.',
                '',
                'Repère — organisation & sérénité',
            ].join('\n'),
            titre: 'Vous êtes invité à rejoindre un dossier',
            paragraphes: (inviterName) => [
                'Bonjour,',
                `${inviterName} utilise Repère pour organiser le quotidien de vos enfants et vous propose de rejoindre le dossier.`,
                "Repère protège les deux parents de la même façon : vous y aurez exactement les mêmes droits, et l'historique n'appartient à aucun des deux. Personne ne peut en retirer quoi que ce soit, ni vous en exclure.",
            ],
            bouton: 'Rejoindre le dossier',
            note: "Ce lien est valable 30 jours. Si vous préférez ne pas l'utiliser, vous pouvez ignorer ce message : rien ne se passera.",
        },
        digest: {
            objet: 'Du nouveau dans votre dossier Repère',
            texte: (resume, webUrl) => [
                'Bonjour,',
                '',
                `Votre dossier Repère contient ${resume}.`,
                '',
                'Pour le consulter :',
                webUrl,
                '',
                'Vous pouvez régler vos heures silencieuses et la fréquence de ces messages',
                'dans les préférences de votre compte.',
                '',
                'Repère — organisation & sérénité',
            ].join('\n'),
            titre: 'Du nouveau dans votre dossier',
            paragraphes: (resume) => ['Bonjour,', `Votre dossier Repère contient ${resume}.`],
            bouton: 'Ouvrir mon dossier',
            note: 'Vous pouvez régler vos heures silencieuses et la fréquence de ces messages dans les préférences de votre compte.',
        },
        alerte: {
            objetUrgent: 'Alerte urgente sur votre dossier Repère',
            objetNormal: 'Alerte sur votre dossier Repère',
            texte: (motif, webUrl) => [
                'Bonjour,',
                '',
                `Une alerte a été déposée dans votre dossier Repère, au motif « ${motif} ».`,
                '',
                'Pour la lire :',
                webUrl,
                '',
                'Repère — organisation & sérénité',
            ].join('\n'),
            titreUrgent: 'Alerte urgente sur votre dossier',
            titreNormal: 'Alerte sur votre dossier',
            paragraphes: ['Bonjour,', 'Une alerte a été déposée dans votre dossier Repère.'],
            encart: (motif) => `Motif indiqué : « ${motif} »`,
            bouton: "Lire l'alerte",
        },
        invitationPro: {
            objet: 'Un accès professionnel vous a été ouvert sur Repère',
            texte: (modules, url) => [
                'Bonjour,',
                '',
                'Un parent vous a ouvert un accès en consultation à son dossier Repère.',
                '',
                `Vous y verrez : ${modules}.`,
                '',
                "Cet accès est en lecture seule : vous n'y écrivez rien, et rien de ce que vous",
                "consultez n'est modifié par votre passage. Vos consultations sont inscrites au",
                'registre du dossier, que les deux parents peuvent lire.',
                'Chacun des deux parents peut y mettre fin à tout moment.',
                '',
                'Il est gratuit et sans engagement. Pour le retrouver :',
                url,
                '',
                'Repère — organisation & sérénité',
            ].join('\n'),
            titre: 'Un accès professionnel vous a été ouvert',
            paragraphes: (modules) => [
                'Bonjour,',
                'Un parent vous a ouvert un accès en consultation à son dossier Repère.',
                `Vous y verrez : ${modules}.`,
                "Cet accès est en lecture seule : vous n'y écrivez rien, et rien de ce que vous consultez n'est modifié par votre passage. Vos consultations sont inscrites au registre du dossier, que les deux parents peuvent lire. Chacun des deux parents peut y mettre fin à tout moment.",
                'Il est gratuit et sans engagement.',
            ],
            bouton: 'Ouvrir mon accès',
        },
        lienPaiement: {
            objet: 'Votre lien pour vous abonner à Repère',
            texte: (lien) => [
                'Bonjour,',
                '',
                'Vous venez de demander à vous abonner depuis l’application Repère.',
                'Ouvrez ce lien pour terminer, sur cet appareil ou sur un autre :',
                lien,
                '',
                'Ce lien est valable 1 heure. Passé ce délai, redemandez-le depuis l’application.',
                'Rien ne vous est débité tant que vous n’avez pas confirmé.',
                '',
                '— Repère',
            ].join('\n'),
            titre: 'Terminer votre abonnement',
            paragraphes: [
                'Vous venez de demander à vous abonner depuis l’application. Le paiement se termine ici, sur cet appareil ou sur un autre.',
                'Rien ne vous est débité tant que vous n’avez pas confirmé.',
            ],
            bouton: 'Terminer le paiement',
            note: 'Ce lien est valable 1 heure. Passé ce délai, redemandez-le depuis l’application.',
        },
        reinitialisation: {
            objet: 'Réinitialisation de votre mot de passe',
            texte: (lien) => [
                'Bonjour,',
                '',
                'Vous avez demandé à réinitialiser votre mot de passe Repère. Ouvrez ce lien :',
                lien,
                '',
                "Ce lien est valable 1 heure et ne fonctionne qu'une fois.",
                "Si vous n'êtes pas à l'origine de cette demande, ignorez ce message :",
                'votre mot de passe actuel reste valable.',
                '',
                'Repère — organisation & sérénité',
            ].join('\n'),
            titre: 'Réinitialisation de votre mot de passe',
            paragraphes: ['Bonjour,', 'Vous avez demandé à réinitialiser votre mot de passe Repère.'],
            bouton: 'Réinitialiser mon mot de passe',
            note: "Ce lien est valable 1 heure et ne fonctionne qu'une fois. Si vous n'êtes pas à l'origine de cette demande, ignorez ce message : votre mot de passe actuel reste valable.",
        },
        suppressionDossier: {
            objet: 'Une suppression de dossier attend votre validation',
            texte: (demandeur, lien) => [
                'Bonjour,',
                '',
                demandeur
                    ? `${demandeur} a demandé la suppression d'un dossier Repère que vous partagez.`
                    : "Vous avez demandé la suppression d'un de vos dossiers Repère.",
                '',
                "Rien n'est supprimé pour l'instant. La suppression se valide depuis ce lien :",
                lien,
                '',
                'Une fois validée, le dossier reste consultable trente jours sans pouvoir être',
                'modifié, puis il est détruit définitivement. Pendant ce délai, la suppression',
                "peut être annulée à tout moment, par l'un comme par l'autre.",
                '',
                "Ce lien est valable 7 jours. Sans réponse, la demande s'annule d'elle-même et le",
                'dossier reste intact.',
                '',
                'Repère — organisation & sérénité',
            ].join('\n'),
            titre: 'Une suppression de dossier attend votre validation',
            paragraphes: (demandeur) => [
                'Bonjour,',
                demandeur
                    ? `${demandeur} a demandé la suppression d'un dossier Repère que vous partagez.`
                    : "Vous avez demandé la suppression d'un de vos dossiers Repère.",
                "Rien n'est supprimé pour l'instant. Une fois la suppression validée, le dossier reste consultable trente jours sans pouvoir être modifié, puis il est détruit définitivement. Pendant ce délai, elle peut être annulée à tout moment, par l'un comme par l'autre.",
            ],
            bouton: 'Ouvrir la demande',
            note: "Ce lien est valable 7 jours. Sans réponse, la demande s'annule d'elle-même et le dossier reste intact.",
        },
    },
    mobile: {
        notifications: {
            verification: 'Notifications : vérification…',
            pretes: 'Notifications prêtes sur cet appareil.',
            refusees: 'Vous avez refusé les notifications. Vous pouvez les réactiver dans les réglages du téléphone.',
            indisponiblesTitre: 'Notifications indisponibles',
            appareilRattacheTitre: 'Appareil rattaché',
            appareilActif: 'Cet appareil est enregistré. Vous serez prévenu même application fermée.',
            appareilInactif: 'Vous êtes connecté, mais cet appareil ne peut pas encore être prévenu.',
        },
        dossiers: {
            titre: 'Vos dossiers',
            chargement: 'Chargement…',
            erreur: 'Impossible de charger vos dossiers.',
            aucun: "Aucun dossier pour l'instant. Vous pouvez en créer un depuis l'application web.",
            deconnexion: 'Se déconnecter',
            ouvrirIndice: 'Ouvre le calendrier de ce dossier',
        },
        calendrier: {
            retour: 'Retour',
            aujourdHui: "Aujourd'hui",
            jusqua: (heure) => `Jusqu'à ${heure}`,
        },
    },
};
//# sourceMappingURL=fr.js.map